export const getReservationOffers = /* GraphQL */ `
  query GetReservationOffers(
    $companyIds: [ID!]
    $startCompanyId: ID
    $group: String
    $orgBusinessId: ID
    $startTime: AWSDateTime!
    $returnTime: AWSDateTime!
    $timeFlexibility: Int!
  ) {
    getReservationOffers(
      companyIds: $companyIds
      startCompanyId: $startCompanyId
      group: $group
      orgBusinessId: $orgBusinessId
      startTime: $startTime
      returnTime: $returnTime
      timeFlexibility: $timeFlexibility
    ) {
      vehicle {
        id
        group
        organizationId
        orgBusinessId
        companyId
        name
        nameT {
          fi
          en
          sv
        }
        registrationPlate
        createdAt
        updatedAt
        includedDistance
        deductible
        extraInfo
        additionalFields {
          key
          value
          valueT {
            fi
            en
            sv
          }
        }
        category {
          id
          image
          name
          typeId
        }
        image
        orderNumber
        useStartReturnTimes
        startReturnTimes {
          start
          return
        }
        customStartReturns {
          priority
          startReturnInterval {
            start
            end
          }
          startReturnTimes {
            start
            return
          }
        }
      }
      startTime
      returnTime
      vehicleOfferPrice
      tax
      additionalServiceOffers {
        key
        offerPrice
        tax
        deductibleValue
        description
        descriptionT {
          fi
          en
          sv
        }
        category
        adHocService
        image
      }
      freeTimes {
        returnTimes {
          start
          end
        }
        firstStartTime
        lastStartTime
        lastReturnTime
      }
      reservedTimes {
        start
        end
      }
      availableInCategory
      useVehicleTimes
      disableOffHourReturn
    }
  }
`;

export const getReservationsMonthly = /* GraphQL */ `
  query GetReservationsMonthly($companyId: ID!, $dateInMonth: AWSDateTime!) {
    getReservationsMonthly(companyId: $companyId, dateInMonth: $dateInMonth) {
      vehicle {
        id
        group
        companyId
        name
        registrationPlate
        createdAt
        updatedAt
        includedDistance
        additionalFields {
          key
          value
        }
        category {
          id
          name
        }
        image
        orderNumber
        useStartReturnTimes
        startReturnTimes {
          start
          return
        }
      }
      reservedTimes {
        start
        end
      }
      useVehicleTimes
    }
  }
`;

export const companyByOrganization = /* GraphQL */ `
  query CompanyByOrganization(
    $organizationId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelCompanyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    companyByOrganization(
      organizationId: $organizationId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        categories {
          items {
            id
            typeId
            name
            image
            orderNumber
          }
        }
        group
        organizationId
        orgBusinessId
        name
        displayName
        email
        address
        deliveryBufferHours
        postalCode
        city
        orderNumber
        phone
        businessId
        termsUrl
        timezone
        currency
        locale
        weeklyBusinessHours {
          openAt
          closeAt
        }
        createdAt
        updatedAt
        creditCheck {
          enabled
        }
        businessHoursExceptions {
          items {
            date
            businessHours {
              openAt
              closeAt
            }
          }
          nextToken
        }
        enableReservationDeposit
        enableRegistrationPlate
        reservationDeposit {
          amount
          reminderBefore
          paymentBefore
        }
        disableOffHourReturn
        disableMultiday
        disableSameDay
        disableStartDaysFromNow
        enableCart
        enableMonthlyView
        enableMustSign
        enablePaymentOnlineOnly
        enableVehicleStartReturnTimes
        enableGTM
        hidden
        contractSettingsJSON
        features {
          enableNPS
          enableVismaPay
          enableReservationDialogV2
          enableGTM
          enableMustSignBypass
          disableCreditCheckBox
        }
      }
      nextToken
      __typename
    }
  }
`;

export const companyByBusiness = /* GraphQL */ `
  query CompanyByBusiness(
    $orgBusinessId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelCompanyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    companyByBusiness(
      orgBusinessId: $orgBusinessId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        categories {
          items {
            id
            typeId
            name
            image
            orderNumber
          }
        }
        group
        organizationId
        orgBusinessId
        name
        displayName
        email
        address
        postalCode
        deliveryBufferHours
        city
        orderNumber
        phone
        businessId
        termsUrl
        timezone
        currency
        locale
        weeklyBusinessHours {
          openAt
          closeAt
        }
        createdAt
        updatedAt
        creditCheck {
          enabled
        }
        businessHoursExceptions {
          items {
            date
            businessHours {
              openAt
              closeAt
            }
          }
          nextToken
        }
        enableReservationDeposit
        enableRegistrationPlate
        reservationDeposit {
          amount
          reminderBefore
          paymentBefore
        }
        disableOffHourReturn
        disableMultiday
        disableSameDay
        disableStartDaysFromNow
        enableCart
        enableMonthlyView
        enableMustSign
        enablePaymentOnlineOnly
        enableVehicleStartReturnTimes
        enableGTM
        hidden
        contractSettingsJSON
        features {
          enableNPS
          enableVismaPay
          enableReservationDialogV2
          enableGTM
          enableMustSignBypass
          disableCreditCheckBox
        }
      }
      nextToken
      __typename
    }
  }
`;

export const companyByGroup = /* GraphQL */ `
  query CompanyByGroup(
    $group: String
    $sortDirection: ModelSortDirection
    $filter: ModelCompanyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    companyByGroup(
      group: $group
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        categories {
          items {
            id
            typeId
            name
            image
            orderNumber
          }
        }
        group
        organizationId
        orgBusinessId
        name
        deliveryBufferHours
        displayName
        email
        contractSettingsJSON
        address
        postalCode
        city
        orderNumber
        phone
        businessId
        termsUrl
        timezone
        currency
        locale
        weeklyBusinessHours {
          openAt
          closeAt
        }
        createdAt
        updatedAt
        creditCheck {
          enabled
        }
        businessHoursExceptions {
          items {
            date
            businessHours {
              openAt
              closeAt
            }
          }
          nextToken
        }
        enableReservationDeposit
        enableRegistrationPlate
        reservationDeposit {
          amount
          reminderBefore
          paymentBefore
        }
        disableOffHourReturn
        disableMultiday
        disableSameDay
        disableStartDaysFromNow
        enableCart
        enableMonthlyView
        enableMustSign
        enablePaymentOnlineOnly
        enableVehicleStartReturnTimes
        enableGTM
        hidden
        features {
          enableNPS
          enableVismaPay
          enableReservationDialogV2
          enableGTM
          enableMustSignBypass
          disableCreditCheckBox
        }
      }
      nextToken
      __typename
    }
  }
`;
export const listCompanys = /* GraphQL */ `
  query ListCompanys(
    $filter: ModelCompanyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCompanys(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        categories {
          items {
            id
            typeId
            name
            image
            orderNumber
          }
        }
        group
        organizationId
        orgBusinessId
        name
        displayName
        email
        address
        postalCode
        deliveryBufferHours
        city
        orderNumber
        phone
        businessId
        termsUrl
        timezone
        currency
        locale
        contractSettingsJSON
        weeklyBusinessHours {
          openAt
          closeAt
        }
        createdAt
        updatedAt
        creditCheck {
          enabled
        }
        businessHoursExceptions {
          items {
            date
            businessHours {
              openAt
              closeAt
            }
          }
          nextToken
        }
        enableReservationDeposit
        enableRegistrationPlate
        reservationDeposit {
          amount
          reminderBefore
          paymentBefore
        }
        disableOffHourReturn
        disableMultiday
        disableSameDay
        disableStartDaysFromNow
        enableCart
        enableMonthlyView
        enableMustSign
        enablePaymentOnlineOnly
        enableVehicleStartReturnTimes
        enableGTM
        hidden
        features {
          enableNPS
          enableVismaPay
          enableReservationDialogV2
          enableGTM
          enableMustSignBypass
          disableCreditCheckBox
        }
      }
      nextToken
    }
  }
`;

export const getCompany = /* GraphQL */ `
  query GetCompany($id: ID!) {
    getCompany(id: $id) {
      termsUrl
      id
      group
      enableMustSign
      enablePaymentOnlineOnly
      enableReservationDeposit
      enableGTM
      reservationDeposit {
        amount
        reminderBefore
        paymentBefore
      }
      creditCheck {
        enabled
      }
      features {
        enableNPS
        enableVismaPay
        enableReservationDialogV2
        enableGTM
        enableMustSignBypass
        disableCreditCheckBox
      }
      name
      contractSettingsJSON
      timezone
      currency
      locale
      address
      postalCode
      city
      phone
      businessId
    }
  }
`;

export const authPayment = /* GraphQL */ `
  query AuthPayment(
    $reservationId: ID!
    $paymentMethod: PaymentMethodInput
    $origin: String
  ) {
    authPayment(
      reservationId: $reservationId
      paymentMethod: $paymentMethod
      origin: $origin
    ) {
      result
      token
      type
    }
  }
`;

export const getPaymentMethods = /* GraphQL */ `
  query GetPaymentMethods {
    getPaymentMethods {
      name
      selected_value
      group
      min_amount
      max_amount
      img
      img_timestamp
      currency
    }
  }
`;

export const getChannelPaymentMethods = /* GraphQL */ `
  query GetChannelPaymentMethods($companyId: ID!, $currency: String) {
    getChannelPaymentMethods(companyId: $companyId, currency: $currency) {
      name
      selected_value
      group
      min_amount
      max_amount
      img
      img_timestamp
      currency
    }
  }
`;
